export const LONG_PRESS_DELAY = 2000 //ms